import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock"; // Import a lock icon
import { useKeycloak } from "@react-keycloak/web";
import { BASENAME } from "./config/settings";

const PrivateRoute = ({ children }) => {
  const { keycloak, initialized } = useKeycloak();

  if (!initialized) {
    return (
      <Box sx={{ p: 5 }}>
        <span>Loading...</span>
      </Box>
    );
  }

  if (!keycloak.authenticated) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Card sx={{ p: 4, textAlign: "center", maxWidth: 400 }}>
          <CardContent>
            <LockIcon sx={{ fontSize: 50, color: "error.main", mb: 2 }} />
            <Typography variant="h5" gutterBottom>
              Access Restricted
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Please log in to access this page.
            </Typography>
            <Button
              onClick={() =>
                keycloak.login({
                  redirectUri: window.location.origin + BASENAME + "/",
                })
              }
              variant="contained"
              color="primary"
            >
              Login
            </Button>
          </CardContent>
        </Card>
      </Box>
    );
  }
  return <>{children}</>;
};

export default PrivateRoute;
